import * as ActionTypes from '../constants/ActionTypes'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

const getMe = () => {


  return (dispatch) => {
    dispatch(loading());
    dispatch(loading());
  }
};


export default {
  getMe
}

